import { call, put } from 'redux-saga/effects';
import { api as translationApi } from '../../api/lelyBackend/translationApi';
import i18n, { updateI18nLanguage } from './i18n';
import clientSideTranslations from './clientSideTranslations';
import withLoading from '../../sagas/loadingSaga';
import { setTranslations } from '../../reducers/translationSlice';

export default function* fetchTranslations(language: string) {
  yield* withLoading(function* () {
    const response = yield call(translationApi.getTranslations, language);
    const serverTranslations = response.data;

    const clientTranslations = clientSideTranslations(language);
    const mergedTranslations = { ...serverTranslations, ...clientTranslations };

    // Store translations in Redux state
    yield put(setTranslations(mergedTranslations));

    // Get all namespaces from the response
    const namespaces = Object.keys(mergedTranslations);
    // Add each namespace bundle
    namespaces.forEach((namespace) => {
      i18n.addResourceBundle(
        language, // language
        namespace, // namespace
        mergedTranslations[namespace], // data
        true, // deep merge
        true, // overwrite
      );
    });

    yield call(updateI18nLanguage, language);
  });
}
